<template>
  <div id="scale_drawer">
    <div @click="onClose" style="cursor: pointer;padding: 32px 0px 32px 40px" >
      <a-icon type="left" />
      <span style="color: #262626; display: inline-block; margin-left: 10px;">返回</span>
    </div>
    <div style="padding: 0px 40px 40px; box-sizing: border-box;">
      <div style="display: flex; justify-content: space-between; align-items: flex-end;">
        <div>
          <span style="color: #8C8C8C;">测评名称</span>
          <h2 style="font-size: 24px; margin-top: 16px; font-weight: bold;">{{scaleText.title}}</h2>
        </div>
        <a-button v-if="scaleItem && scaleItem.RIGHT && roleID === 1" type="primary" @click="createHand">创建测评任务</a-button>
        <a-tooltip v-else>
          <template slot="title" v-if="roleID === 1">该量表还未开通</template>
          <template slot="title" v-else>仅限超级管理员使用</template>
          <span class="tool_btn">创建测评任务</span>
        </a-tooltip>
      </div>
      <div style="margin-top: 32px;">
        <span style="color: #8C8C8C;">包含量表</span>
        <div class="drawer_con drawer_flex">
          <div class="drawer_flex">
            <img src="@/assets/drawer_icon.png" alt="">
            <span>{{scaleText.surveyTitle}}</span>
          </div>
          <span @click="previewHandle(scaleText.surveyLink)" style="color: #51BF94; cursor: pointer;">题目预览</span>
        </div>
        <div class="drawer_flex drawer_detail">
          <div class="drawer_flex">
            <span style="color: #8C8C8C">题目：</span>
            <span style="margin-right: 40px">{{scaleText.surveyNum}}题</span>
          </div>
          <div class="drawer_flex">
            <span style="color: #8C8C8C">预计用时：</span>
            <span>{{scaleText.surveyTime}}分钟</span>
          </div>
        </div>
      </div>
      <div style="margin-top: 32px;">
        <span style="color: #8C8C8C;">测评说明</span>
        <p style="margin-top: 16px; line-height: 21px;">{{scaleText.surveyCon}}</p>
        <p v-if="scaleText.surveyConTwo" style="margin-top: 16px; line-height: 21px;">{{scaleText.surveyConTwo}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  name: 'ScaleDrawer',
  props: ['scaleText'],
  data () {
    return {
      scaleItem: null,
      roleID: null
    }
  },
  computed: {
    ...mapState([
      'allSurveys'
    ])
  },
  watch: {
    scaleText () {
      this.scaleItem = this.allSurveys.filter(item => item.ID === this.scaleText.scaleId)[0]
    }
  },
  mounted () {
    this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
    this.scaleItem = this.allSurveys.filter(item => item.ID === this.scaleText.scaleId)[0]
  },
  methods: {
    ...mapMutations([
      'setDistributeItem'
    ]),
    ...mapActions([
      'getGradeClass'
    ]),
    onClose() {
      this.$emit('drawerVisible', false)
    },
    async createHand () {
      await this.getGradeClass()
      this.setDistributeItem({type: 0, ID: this.scaleText.scaleId, SURVEY_TITLE: this.scaleText.surveyTitle})
      this.$router.push('/evaluationList/distributionDetail')
    },
    previewHandle (url) {
      window.open(url)
    }
  }
}
</script>

<style>
#scale_drawer {
  color: #262626;
}
#scale_drawer .drawer_flex {
  display: flex;
  align-items: center;
}
#scale_drawer .ant-btn-primary {
  height: 40px;
  padding: 0px 45px;
  border-radius: 20px;
  background: #51BF94;
}
#scale_drawer .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
#scale_drawer .drawer_con {
  width: 100%;
  margin-top: 16px;
  justify-content: space-between;
}
#scale_drawer .drawer_con img {
  width: 16px;
  height: auto;
  margin-right: 8px;
}
#scale_drawer .drawer_detail {
  margin-top: 24px;
}
#scale_drawer .tool_btn {
  display: inline-block;
  color: #FFFFFF;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 40px;
  border-radius: 20px;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #BFBFBF;
}
</style>